import React from 'react';
import { useDispatch } from 'react-redux';
import { getSecurityProfile } from '../components/agent/actions';
import { useCookies } from 'react-cookie';
import { useSelector } from 'react-redux';
import * as constants from '../constants/index';
import { useSetLocale } from 'react-admin';
import { useAuthState } from 'react-admin';
import { usePermissions } from 'react-admin';
import { getAppInfo, getIamLists } from '../components/authentication/actions';

export default function InitialComponent() {
    const dispatch = useDispatch();
    const [cookies] = useCookies(['csrfToken']);
    const locale = useSelector((state: constants.AppState) => state.locale);
    const setLocale = useSetLocale();
    const { loading, authenticated } = useAuthState();
    const { loaded, permissions } = usePermissions();

    const initialProfile = () => {
        //dispatch(getAppInfo());

        sessionStorage.setItem('csrfToken', cookies['XSRF-TOKEN']);
        dispatch(getIamLists());

        if (permissions.ALLOWED.includes(constants.PERMISSION_ACTIONS.GET_SECURITY_PROFILE)) {
            dispatch(getSecurityProfile());
        }
    };

    React.useEffect(() => {
        if (!loading && authenticated && loaded) {
            initialProfile();
        }
    }, [loading, authenticated, loaded]);

    React.useEffect(() => {
        setLocale(locale as string);
    }, [locale]);

    return <React.Fragment />;
}
